import PropTypes from "prop-types";
import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
// basic
import About from "../../pages/About";
// custom
import Dashboard from "../../pages/Dashboard";
import Logout from "../../pages/Logout";
import Profile from "../../pages/Profile";
import Support from "../../pages/Support";
import AppEdit from "../../pages/apps/AppEdit";
import Apps from "../../pages/apps/Apps";
import CustomerEdit from "../../pages/customers/CustomerEdit";
import CustomerView from "../../pages/customers/CustomerView";
import Customers from "../../pages/customers/Customers";
import LicenseEdit from "../../pages/licenses/LicenseEdit";
import Licenses from "../../pages/licenses/Licenses";
import FourOhThree from "../pages/403";
import { PageDelete, PageView } from "../pages/index";

// import gTemplate from "../../services/gTemplate";
// import Caba from "../../services/Caba";

class Switcher extends Component {
  static propTypes = {
    viewProps: PropTypes.object
  };

  state = {
    routes: [
      // basic
      {
        handler: About,
        path: "/about",
        hasScope: true,
        exact: true
      },
      {
        handler: Support,
        path: "/support",
        hasScope: true,
        exact: true
      },
      {
        handler: Profile,
        path: "/profile",
        hasScope: true,
        exact: true
      },
      {
        handler: Logout,
        path: "/logout",
        hasScope: true,
        exact: true
      },
      // custom
      {
        handler: Dashboard,
        path: "/",
        hasScope: true,
        exact: true
      },
      {
        handler: Apps,
        path: "/apps",
        hasScope: true,
        exact: true,
        props: {
          slug: "apps",
          button: true,
          dialog: {
            subtitle: "New app",
            button: "Create"
          }
        }
      },
      {
        handler: PageView,
        path: "/apps/:id/view",
        hasScope: true,
        exact: true,
        props: {
          slug: "apps"
        }
      },
      {
        handler: AppEdit,
        path: "/apps/:id/edit",
        hasScope: true,
        exact: true,
        props: {
          slug: "apps"
        }
      },
      {
        handler: PageDelete,
        path: "/apps/:id/delete",
        hasScope: true,
        exact: true,
        props: {
          slug: "apps"
        }
      },
      {
        handler: Customers,
        path: "/customers",
        hasScope: true,
        exact: true,
        props: {
          slug: "customers",
          button: true,
          dialog: {
            subtitle: "New customer",
            button: "Create"
          }
        }
      },
      {
        handler: CustomerView,
        path: "/customers/:id/view",
        hasScope: true,
        exact: true,
        props: {
          slug: "customers"
        }
      },
      {
        handler: CustomerEdit,
        path: "/customers/:id/edit",
        hasScope: true,
        exact: true,
        props: {
          slug: "customers"
        }
      },
      {
        handler: PageDelete,
        path: "/customers/:id/delete",
        hasScope: true,
        exact: true,
        props: {
          slug: "customers"
        }
      },
      {
        handler: Licenses,
        path: "/licenses",
        hasScope: true,
        exact: true,
        props: {
          slug: "licenses"
        }
      },
      {
        handler: PageView,
        path: "/licenses/:id/view",
        hasScope: true,
        exact: true,
        props: {
          slug: "licenses"
        }
      },
      {
        handler: LicenseEdit,
        path: "/licenses/:id/edit",
        hasScope: true,
        exact: true,
        props: {
          slug: "licenses"
        }
      },
      {
        handler: PageDelete,
        path: "/licenses/:id/delete",
        hasScope: true,
        exact: true,
        props: {
          slug: "licenses"
        }
      }
    ]
  };

  render() {
    const { viewProps } = this.props;
    const { routes } = this.state;
    return (
      <Switch>
        {routes.map(route => {
          // exit if scope is false
          if (!route.hasScope) route.handler = FourOhThree;
          return (
            <Route
              exact={route.exact}
              path={route.path}
              render={() => <route.handler {...viewProps} {...route.props} />}
              key={route.path}
            />
          );
        })}
      </Switch>
    );
  }
}

export default Switcher;



// WEBPACK FOOTER //
// ./src/library/helper/Switcher.js